import { generateIconComponent } from './icons.utils';

export const ArrowLeftSolidIcon = generateIconComponent({
    name: 'ArrowLeftSolidIcon',
    viewBox: '0 0 24 24',
    path: (
        <path d="M9.59263 3.25072L10.8047 4.46277C11.139 4.79706 11.139 5.34051 10.8047 5.67481L5.85192 10.6276H23.1428C23.6177 10.6276 24 11.0116 24 11.4847V13.1991C24 13.674 23.6177 14.0563 23.1428 14.0563H5.85192L10.8047 19.009C11.139 19.345 11.139 19.8867 10.8047 20.221L9.59263 21.4331C9.25833 21.7691 8.71488 21.7691 8.38058 21.4331L0.501444 13.5539C-0.167151 12.8854 -0.167151 11.8002 0.501444 11.1299L8.38058 3.25072C8.71488 2.91643 9.25833 2.91643 9.59263 3.25072Z" />
    ),
});
